import { IRoute } from '@interfaces/route.interface'
import { EUserRoles } from '@enums/roles'
import { routersPath } from '@router/routes-path'
import React from 'react'
import CrmStatPage from '../pages/CrmPage/pages/StatPage/CrmStatPage'
import PaymentPage from '../pages/CrmPage/pages/PaymentPage/PaymentPage'
import SubscriptionPage from '../pages/CrmPage/pages/SubscriptionPage/SubscriptionPage'

export const crmRoutes: IRoute[] = [
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.CRM_STAT,
    component: <CrmStatPage />,
    title: 'Crm Статистика',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.CRM_PAYMENTS,
    component: <PaymentPage />,
    title: 'Crm Оплаты',
  },
  {
    roles: [EUserRoles.SUPER_ADMIN],
    path: routersPath.CRM_SUBSCRIPTIONS,
    component: <SubscriptionPage />,
    title: 'Crm Подписки',
  },
]
